export default [
	{
		path: '/inspection/start/:projectID/:propertyID/:scheduleID',
		name: 'inspectionStart',
		component: () => import(/* webpackChunkName: "inspectionStart" */ '@/views/inspection/Index.vue'),
		meta: {
			title: 'Objectgegevens',
			requiresAuth: true,
		}
	},
	{
		path: '/inspection/inspect/:projectID/:propertyID/:scheduleID/:inspectionID',
		name: 'inspectionInspect',
		component: () => import(/* webpackChunkName: "inspectionInspect" */ '@/views/inspection/Inspect.vue'),
		meta: {
			title: 'Opname uitvoeren',
			requiresAuth: true,
		}
	},
	{
		path: '/inspection/edit/:projectID/:propertyID/:scheduleID/:inspectionID',
		name: 'inspectionEdit',
		component: () => import(/* webpackChunkName: "inspectionEdit" */ '@/views/inspection/Inspect.vue'),
		meta: {
			title: 'Opname openen',
			requiresAuth: true,
		}
	},
];